import React from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import Button from "../ui/Button";
import logo from "../../img/logo-yellow.png";

const HeroSection = () => {
  const scrollToProducts = () => {
    document.getElementById("products")?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#0d1442] via-[#1a237e] to-[#0d1442]">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#f9d71c]/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#f9d71c]/5 rounded-full blur-3xl animate-pulse delay-1000" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] border border-white/5 rounded-full" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-white/5 rounded-full" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-10"
        >
          <div className="inline-flex items-center justify-center">
            <img
              src={logo}
              alt="Jasmine Enterprises"
              className="h-32 md:h-40 lg:h-48 object-contain"
            />
          </div>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-4xl md:text-6xl lg:text-7xl font-light text-white mb-6 tracking-tight"
        >
          <span className="text-[#f9d71c] font-medium">"</span>Strength In Every
          Casting.
          <br />
          <span className="font-medium">Precision In Every Fitting.</span>
          <span className="text-[#f9d71c] font-medium">"</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-lg md:text-xl text-[#f9d71c] max-w-3xl mx-auto mb-12 leading-relaxed"
        >
          A Comprehensive Engineering Solutions Partner, Delivering Castings,
          Precision Parts, And Electrical Power Transmission Components Across
          Multiple Industries.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Button
            onClick={scrollToProducts}
            className="bg-[#f9d71c] text-[#1a237e] hover:bg-[#f9d71c]/90 px-8 py-6 text-lg font-medium rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-[#f9d71c]/20"
          >
            Explore Products
          </Button>
          <Button
            onClick={scrollToContact}
            className="
    bg-white 
    text-[#1a237e]
    hover:bg-gray-300
    hover:text-[#1a237e]
    px-8 py-6
    text-lg font-medium
    rounded-full
    transition-all duration-300
  "
          >
            Get In Touch
          </Button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.2 }}
          className="absolute bottom-7 left-1/2 -translate-x-1/2"
        >
          <ChevronDown className="w-8 h-8 text-white/40 animate-bounce" />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
